import RenderField from '../common/renderField';
import BirthdayField from '../common/birthdayField';

export const declarationSignedFalse = [
  {
    text: "Ім'я пацієнта",
    input: { type: 'text', maxLength: 255, required: true, placeholder: "Ім'я", name: 'name' },
    Component: RenderField,
  },
  {
    text: "Прізвище пацієнта",
    input: { type: 'text', maxLength: 255, required: true, placeholder: "Прізвище", name: 'last_name' },
    Component: RenderField,
  },
  {
    text: "Дата народження",
    input: { type: 'birthday', required: true, name: 'birthday' },
    Component: BirthdayField
  },
  {
    text: 'Причина звернення',
    input: { type: 'text', placeholder: 'Причина...', maxLength: 255, name: 'reserv_comment', required: true },
    Component: RenderField,
  },
];
